export const zonas = [
    {
    titulo: "Laguna Yarinacocha",
    descripcion: "Ubicada a 15 minutos del centro de Pucallpa, esta laguna es ideal para paseos en bote, avistamiento de aves y contacto con comunidades indígenas como los Shipibo-Conibo.",
    imagen: "/imagenes/turismo/lagunaYarina.webp"
    },
    {
    titulo: "Parque Natural de Pucallpa",
    descripcion: "Zoológico y reserva natural en plena ciudad, con más de 400 especies de flora y fauna silvestres.",
    imagen: "/imagenes/turismo/parqueNatural.webp"
    },
    {
    titulo: "Cataratas Velo de la Novia",
    descripcion: "Hermosas cataratas rodeadas de selva, ideales para caminatas y baños refrescantes.",
    imagen: "/imagenes/turismo/veloDenovia.webp"
    },
    {
    titulo: "Boquerón del Padre Abad",
    descripcion: "Formaciones rocosas gigantes y caídas de agua a lo largo de la carretera Federico Basadre.",
    imagen: "/imagenes/turismo/boqueron.webp"
    },
    {
    titulo: "Comunidad Nativa San Francisco",
    descripcion: "Experiencia cultural con medicina tradicional, arte textil, gastronomía y danzas típicas.",
    imagen: "/imagenes/turismo/comunidaNativa.webp"
    },
    {
        titulo: 'Cataratas de Regalías (Curimaná)',
        descripcion: 'Ubicadas en el distrito de Curimaná, estas cataratas ofrecen un entorno natural impresionante, rodeadas de bosque tropical y senderos ideales para el ecoturismo.',
        imagen: '/imagenes/turismo/regalias.webp', 
    },
];